<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-2">
      <div class="d-flex align-items-center" style="gap:10px">
        <div class="section-title">{{ $tc("contract", 2) }}</div>

          <div>
        <b-form-input
          v-debounce:300="getContractsList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      </div>


      <div class="d-flex align-items-center">
        <div>
        <b-button variant="default" to="add-contract" class="btn-blue">{{
          $tc("add")
        }}</b-button>
        </div>


        <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>


      </div>
    </div>

  

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(contract, contractKey) in ms_contracts"
        :key="contractKey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ contract.contract_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/distributor/edit-contract', contract)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/distributor/view-contract', contract)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="contract.contract_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  contract.contract_is_active == 'Y' ? 'active' : 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView" style="margin-bottom:25px;">
      <thead>
        <tr>
           <th class="text-left" style="width:100px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>

          <th class="text-center" style="width:175px">
            <img
              v-if="this.columnName != 'contract_name'"
              @click="onSortValue('contract_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('contract_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('contract_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("contract", 2) }} {{ $tc("name", 2) }}
          </th>
          <th class="text-left" style="">
            <img
              v-if="this.columnName != 'contract_value'"
              @click="onSortValue('contract_value', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('contract_value', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('contract_value', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />{{ $tc("distributor", 2) }} {{ $tc("share", 2) }}
          </th>
         
        </tr>
      </thead>
      <tbody v-if="ms_contracts.length > 0">
        <tr v-for="(contract, contractKey) in ms_contracts" :key="contractKey" class="light_grey_back">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <!-- <label class="ios-switch">
                <input
                  :checked="contract.contract_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  contract.contract_is_active == 'Y' ? 'active' : 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-2">
                <b-dropdown-item
                  @click="goToRoute('/distributor/edit-contract', contract)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/distributor/view-contract', contract)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>

          <td style="">{{ contract.contract_name }}</td>
          <td class="text-left" style="padding-right:0px;padding-left:110px">
            {{ contract.contract_value }}
            {{ contract.contract_is_percentage == "Y" ? "%" : "" }}
          </td>
          
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="3">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords/>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import { BASEURL } from "@/config/index.js";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";


export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      gridView: false,
      listView: true,
      ms_contracts: [],
      viewingnumbers: [],
      URL_BASE: BASEURL,
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",

      debounce: null,
      searchValue: "",
      searchKey: "contract_name"
    };
  },
  beforeMount() {
    this.getviewingnumber();
  },
  mounted() {
    this.getContractsList();
  },
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getContractsList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getContractsList();
      } else {
        this.currentPage = event;
        this.getContractsList();
      }
    },
    getContractsList: function() {
      let payload = {
        tableName: "ms_contracts",
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        searchValue: this.searchValue,
        searchKey: this.searchKey
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.ms_contracts = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    goToRoute: function(path, { contract_id }) {
      this.$router.push({
        path: path,
        query: {
          contract_id: contract_id
        }
      });
    },
    /* eslint-disable */

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/ContractComponents/contract.vue